import React from "react";
import { useField } from "formik";

export default function InputField(props) {
  const {
    label,
    subLabel,
    required,
    type = "text",
    fullWidth,
    style,
    ...rest
  } = props;
  const [field, meta] = useField(props);
  const getFontSize = () => {
    const width = window.innerWidth;
    if (width < 480) return "0.75rem";
    if (width < 768) return "0.875rem";
    return "1rem";
  };

  const getFontSizeSub = () => {
    const width = window.innerWidth;
    if (width < 480) return "0.75rem";
    return "0.875rem";
  };

  const showError = meta.touched && meta.error;

  return (
    <div className={`${fullWidth ? "col-md-12" : "col-md-6"} mb-3`}>
      {label && (
        <label
          className="form-label d-block"
          htmlFor={field.name}
          style={{ fontSize: getFontSize() }}
        >
          {label}
          {required && <span className="text-danger">*</span>}
        </label>
      )}
      {subLabel && (
        <label
          className="form-label d-block"
          htmlFor={field.name}
          style={{ fontSize: getFontSizeSub() }}
        >
          {subLabel}
          {required && <span className="text-danger">*</span>}
        </label>
      )}
      <input
        className={`form-control ${showError ? "is-invalid" : ""} ${
          type === "email" ? "text-lowercase" : "text-capitalize"
        }`}
        type={type}
        style={{ ...style, fontSize: getFontSize() }}
        {...field}
        {...rest}
      />
    </div>
  );
}
